export default __webpack_public_path__ + "static/media/hip.4426224b.png";